import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-50 bg-[#1B2A4A]/95 backdrop-blur-md border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-white/70 text-xs leading-relaxed">
          Este sitio utiliza únicamente cookies técnicas imprescindibles.
          Consulte nuestra{' '}
          <a href="/cookies" className="text-[#C58C40] hover:underline">Política de Cookies</a>
          {' '}y{' '}
          <a href="/privacidad" className="text-[#C58C40] hover:underline">Política de Privacidad</a>.
        </p>
        <button
          onClick={accept}
          data-testid="cookie-accept-btn"
          className="flex-shrink-0 bg-[#C58C40] text-white text-xs tracking-wider uppercase px-6 py-2.5 rounded-sm hover:bg-[#b07b35] transition-colors"
        >
          Entendido
        </button>
      </div>
    </div>
  );
}
